const orderPass = (param) => {
    return async (dispatch) => {
        dispatch({
            type:'orderPass',
            data: param
        })
    }
  }
const orderEdit = (param) => {
    return async (dispatch) => {
        dispatch({
            type:'orderEdit',
            data:param
        })
    }
  }
const orderClear = (param) => {
    return async (dispatch) => {
        dispatch({
            type:'orderClear'
        })
    }
  }
const orderInfo = (param) => {
    return async (dispatch) => {
        dispatch({
            type:'orderInfo',
            data: param
        })
    }
  }

const orderCouponAdd = (param) => {
    return async (dispatch) => {
        dispatch({
            type:'orderCouponAdd',
            data: param
        })
    }
  }
  const orderCouponRemove = (param) => {
    return async (dispatch) => {
        dispatch({
            type:'orderCouponRemove',
            data: param
        })
    }
  }
export {orderPass, orderClear, orderEdit, orderInfo, orderCouponAdd, orderCouponRemove}